import { AfterViewInit, ChangeDetectorRef, Component, Inject, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { RideHistoryFacade } from '@ridango/components';
import {
    AppStartupService,
    AuthService,
    OndemandOrderPaymentType,
    OndemandOrderPaymentTypeMap,
    OndemandOrderStatusMap
} from '@ridango/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import momenttz from 'moment-timezone';
import Env from '@ridango/core/env';

@Component({
    templateUrl: './ride-history-page.component.html',
    styleUrls: ['./ride-history-page.component.scss']
})
export class RideHistoryPageComponent implements OnInit, AfterViewInit, OnDestroy {
    private componentDestroyed$ = new Subject<void>();

    rides$ = this.historyFacade.rides$;
    loading$ = this.historyFacade.loading$;
    startDate$ = this.historyFacade.startDate$;
    endDate$ = this.historyFacade.endDate$;
    minStartDate$ = this.historyFacade.minStartDate$;
    minEndDate$ = this.historyFacade.minEndDate$;
    maxStartDate$ = this.historyFacade.maxStartDate$;
    maxEndDate$ = this.historyFacade.maxEndDate$;
    diff$ = this.historyFacade.diff$;

    startDate: Date;
    endDate: Date;
    maxStartDate: Date;
    ridesOrderDescending = false;
    dateFormat = this.env.PRIMARY_DATE_FORMAT;
    rowDateFormat = this.env.TICKET_CARD_DATE_FORMAT;

    token = this.ridangoAuth.getLocalAccessToken();

    constructor(
        @Inject('ENV') public env: Env,
        @Inject(LOCALE_ID) public locale: string,
        private historyFacade: RideHistoryFacade,
        private translate: TranslateService,
        public appStartupService: AppStartupService,
        private ridangoAuth: AuthService,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.locale = this.translate.currentLang;

        this.historyFacade.startDate$
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((startDate) => (this.startDate = startDate));

        this.historyFacade.endDate$
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((endDate) => (this.endDate = endDate));

        const monthsInFuture = this.env.ONDEMAND?.RIDE_HISTORY_MONTHS_IN_FUTURE
            ? this.env.ONDEMAND?.RIDE_HISTORY_MONTHS_IN_FUTURE
            : 3;
        this.maxStartDate = momenttz.tz('Europe/Tallinn').add(monthsInFuture, 'months').toDate();
    }

    ngAfterViewInit() {
        this.historyFacade.fetchRideHistory(this.startDate, this.endDate, this.token);
        this.cdr.detectChanges();
    }

    ngOnDestroy() {
        this.componentDestroyed$.next();
        this.componentDestroyed$.complete();
    }

    startUpdated(date: Date) {
        this.historyFacade.setStartDate(date);
    }

    endUpdated(date: Date) {
        this.historyFacade.setEndDate(date);
    }

    updateList() {
        this.historyFacade.fetchRideHistory(this.startDate, this.endDate, this.token);
    }

    getStatus(statusKey: string) {
        return OndemandOrderStatusMap[statusKey];
    }

    getPaymentMethod(methodKey: string) {
        if (!methodKey) {
            methodKey = OndemandOrderPaymentType.TYPE_NONE;
        }
        return OndemandOrderPaymentTypeMap[methodKey];
    }

    changeSortOrder($event: boolean) {
        this.ridesOrderDescending = $event;
    }
}
